module.exports = __webpack_public_path__ + "static/hostjane-discord-3dcbaa76fa665fd81630929086530633.jpg";